import type { CharacterClass } from '../../types/progression'

/**
 * Clases y sus evoluciones. Los nombres son los del juego.
 * Magic Gladiator, Dark Lord y Rage Fighter no realizan la misión de Sebina.
 */
export const characterClasses: CharacterClass[] = [
  {
    id: 'dk',
    base: 'Dark Knight',
    second: 'Blade Knight',
    third: 'Blade Master',
    baseAliases: ['dk', 'dark knight', 'caballero', 'guerrero'],
    secondAliases: ['bk', 'blade knight'],
    thirdAliases: ['bm', 'blade master'],
    // Variante exacta del objetivo de la misión 1 (14,24@1 es Dark Stone, de Marlon).
    sebinaItem: { itemId: '14,24@0', gameName: 'Broken Sword', esName: 'Espada rota' },
    marlon: true,
    combo: true,
  },
  {
    id: 'dw',
    base: 'Dark Wizard',
    second: 'Soul Master',
    third: 'Grand Master',
    baseAliases: ['dw', 'dark wizard', 'mago', 'hechicero'],
    secondAliases: ['sm', 'soul master'],
    thirdAliases: ['gm', 'grand master'],
    sebinaItem: { itemId: '14,26', gameName: 'Soul Shard of Wizard', esName: 'Alma del mago' },
    marlon: true,
    combo: false,
  },
  {
    id: 'elf',
    base: 'Fairy Elf',
    second: 'Muse Elf',
    third: 'High Elf',
    baseAliases: ['elf', 'fe', 'fairy elf', 'elfa', 'arquera'],
    secondAliases: ['me', 'muse elf'],
    thirdAliases: ['he', 'high elf'],
    sebinaItem: { gameName: 'Tear of Elf', esName: 'Lágrima de elfa' },
    marlon: true,
    combo: false,
  },
  {
    id: 'sum',
    base: 'Summoner',
    second: 'Bloody Summoner',
    third: 'Dimension Master',
    baseAliases: ['sum', 'summoner', 'invocadora'],
    secondAliases: ['bs', 'bloody summoner'],
    thirdAliases: ['dim', 'dimension master'],
    sebinaItem: { gameName: 'Abyssal Eye', esName: 'Ojo abisal' },
    marlon: true,
    combo: false,
  },
  {
    id: 'mg',
    base: 'Magic Gladiator',
    third: 'Duel Master',
    baseAliases: ['mg', 'magic gladiator', 'gladiador'],
    secondAliases: [],
    thirdAliases: ['dm', 'duel master'],
    marlon: false,
    combo: false,
  },
  {
    id: 'dl',
    base: 'Dark Lord',
    third: 'Lord Emperor',
    baseAliases: ['dl', 'dark lord'],
    secondAliases: [],
    thirdAliases: ['le', 'lord emperor'],
    marlon: false,
    combo: false,
  },
  {
    id: 'rf',
    base: 'Rage Fighter',
    third: 'Fist Master',
    baseAliases: ['rf', 'rage fighter', 'peleador'],
    secondAliases: [],
    thirdAliases: ['fm', 'fist master'],
    marlon: false,
    combo: false,
  },
]

export const getClass = (id: string | null | undefined) => characterClasses.find((c) => c.id === id)
